var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"measureFilterPills"},[_c('neb-pill-group',{attrs:{"items":_vm.filterLabels,"wrap":"","itemsClearable":""},on:{"clear":_vm.onClear,"clear-all":function($event){return _vm.$emit('clear-all')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }